import {colors} from "@c10h/colors";
import NextImage from "@components/NextImage";
import {Btn} from "@components/V5Comp";
import {useTranslation} from "ni18n";
import React from "react";

const Price = (): JSX.Element => {
  const i18n = useTranslation();

  return (
    <div className="pv24 ph4-md df jcc tac pv12-md">
      <div>
        <NextImage
          src="/CovidReadyCompliance/401k"
          extension="png"
          width="126"
          height="126"
          alt="401k illustration"
        />
        <div className="mt2">
          <h2 className="fs48 lh12 fs32-md">{i18n.t("$5 per employee, per month")}</h2>
        </div>
        <div className="fs20 font-cm mt4 ls-3">
          {i18n.t("+ additional cost for on-demand testing & symptom tracking")}
        </div>
        <div className="mt10">
          <Btn
            href="#get-started"
            className="mr3 mb3 focus-bsDarkBlue3 fs12-f-xs event-Kv3M6d"
            hoverBg={colors.gray600}
          >
            {i18n.t("Request a Demo")}
          </Btn>
        </div>
      </div>
    </div>
  );
};
export default Price;
